import React from 'react';
import {
  Divider,
  Dropdown, Menu,
  Button,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Text from '../components/basic/Text';
import { ShowIf } from '../components';

function DropDownAction({ data, iteration, length }) {
  const buttonTextStyleNormal = { color: '#898989', padding: '4px 16px', height: '100%' };
  const menu = (
    <Menu>
      {data.children.filter(item => item.visible !== false).map(item => (
        <Menu.Item key={item.translationId}  onClick={() => item.onClick()} >
          <Text translationId={item.translationId}>{item.text}</Text>
        </Menu.Item>
      ))}
    </Menu>
  );
  return (
    <div style={{ height: '100%' }}>
      <Dropdown overlay={menu} trigger="click">
        <Button className="actionLink" type="link" style={buttonTextStyleNormal}>
          <ShowIf condition={data.icon}>
            <FontAwesomeIcon icon={data.icon} />
          </ShowIf>
          <Text style={buttonTextStyleNormal} onClick={e => e.preventDefault()} translationId={data.translationId}>{data.text}</Text>
        </Button>
      </Dropdown>
      <ShowIf condition={iteration < length - 1}>
        <Divider type="vertical" style={{ height: '34px', margin: 0 }} />
      </ShowIf>
    </div>
  );
}
DropDownAction.propTypes = {

};
DropDownAction.defaultProps = {

};
export default DropDownAction;
